class LoaderService {
  addLoader() {
    $("#app").append(
      '<div id="loadingDiv"><div class="loader">Loading...</div></div>'
    );
  }

  removeLoader() {
    $("#loadingDiv").fadeOut(500, function () {
      $("#loadingDiv").remove();
    });
  }
}

export default new LoaderService()



// WEBPACK FOOTER //
// ./src/service/LoaderService.js